import { Categorias } from './../../../../../../_entities/geocerca/Categorias';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material';
import { ToastrService } from 'ngx-toastr';
import { CategoriasService } from '../../../../services/categorias.service';

@Component({
  selector: 'kt-categorias',
  templateUrl: './categorias.component.html',
  styleUrls: ['./categorias.component.scss']
})
export class CategoriasComponent implements OnInit {
  public titulo = ' Categorías Geocerca';
  public catForm: FormGroup;
  public showFilterRow: boolean;
  public showHeaderFilter: boolean;
  public categoriasDataSource: any;
	public datosReporte = [];

  constructor(private fb: FormBuilder, public dialogRef: MatDialogRef<CategoriasComponent>, private toast: ToastrService, private categoriaService: CategoriasService) {
    this.showFilterRow = true;
    this.showHeaderFilter = true;
  }

  ngOnInit() {
    this.initForm();
    this.obtenerCategorias();
  }

  initForm() {
    this.catForm = this.fb.group({
      id: [0],
      nombre: ['',[Validators.required]]
    })
  }

  /**Agregar categorías */
  agregarCategorias(){
    this.categoriaService.agregarCategoria(this.catForm.value).subscribe(result=>{
      this.toast.success("Categoría Registrada")
      this.obtenerCategorias();
      this.initForm();
    },err=>{
      this.toast.error("No se pudo registrar la categoría")
    })
  }

  actualizarCategoria(){
    this.categoriaService.actualizarCategoria(this.catForm.value).subscribe(result=>{
      this.toast.success("Categoría Actualizada")
      this.obtenerCategorias();
      this.initForm();
    },err=>{
      this.toast.error("No se pudo actualizar la categoría")
    })
  }

  /**Obtener Categorías */
  obtenerCategorias() {
    this.categoriaService.obtenerCategorias().subscribe((result: Categorias[]) => {
      this.categoriasDataSource = result;
      this.categoriasDataSource.forEach(geocerca => {
				this.datosReporte.push({
					'Nombre': geocerca.nombre,
				});
			});

    })
  }


  /**Eliminar Categorías */
  eliminarCategoria(id) {
    this.categoriaService.eliminarCategoria(id).subscribe(() => {
      this.toast.success("Categoría Eliminada");
      this.obtenerCategorias();
    }, err => {
      this.toast.error("No se pudo eliminar la categoría")
    })
  }
  /**Obtener categoria por ID */
  obtenerCategoriaId(id) {
    this.categoriaService.obtenerCategoriaId(id).subscribe((result: Categorias) => {
      this.catForm.patchValue(result);
    })
  }

  
	public minimizarPopup() {
		this.dialogRef.addPanelClass('displayNone');
	}

	public maximizarPopup() {
		this.dialogRef.removePanelClass('displayNone');
	}

	public cerrarPopup() {
		this.dialogRef.close();
	}
}
